import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getPin = () => localStorage.getItem("agc_pin") || "";
export const getRole = () => localStorage.getItem("agc_role") || "";
export const getName = () => localStorage.getItem("agc_name") || "";
export const setSession = (pin, role, name = "") => {
  localStorage.setItem("agc_pin", pin);
  localStorage.setItem("agc_role", role);
  localStorage.setItem("agc_name", name || "");
};
export const clearSession = () => {
  localStorage.removeItem("agc_pin");
  localStorage.removeItem("agc_role");
  localStorage.removeItem("agc_name");
};

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const pin = getPin();
  if (pin) cfg.headers["X-Pin"] = pin;
  return cfg;
});

export default client;

// helpers
export const verifyPin = async (pin) => {
  const { data } = await axios.post(`${API}/auth/verify-pin`, { pin });
  return data;
};
export const createClose = async (payload) => (await client.post("/closes", payload)).data;
export const listCloses = async (params) => (await client.get("/closes", { params })).data;
export const listRecentCloses = async () => (await client.get("/closes/recent")).data;
export const attachClosePhotos = async (id, payload) => (await client.post(`/closes/${id}/photos`, payload)).data;
export const recountCash = async (id, denominations, note) =>
  (await client.patch(`/closes/${id}/cash`, { denominations, note })).data;
export const fixDepartments = async (id, group_totals, group_labels, note) =>
  (await client.patch(`/closes/${id}/departments`, { group_totals, group_labels, note })).data;
export const fixExtras = async (id, cheques, gift_cards, other, note) =>
  (await client.patch(`/closes/${id}/extras`, { cheques, gift_cards, other, note })).data;
export const fixCloseDate = async (id, closed_on, note) =>
  (await client.patch(`/closes/${id}/date`, { closed_on, note })).data;
export const pushCloseToSheet = async (id) =>
  (await client.post(`/closes/${id}/push-to-sheet`)).data;
export const getClose = async (id) => (await client.get(`/closes/${id}`)).data;
export const ocrReceipt = async (kind, image_base64, till) =>
  (await client.post("/ocr", { kind, image_base64, till })).data;

export const exportCsvUrl = () => `${API}/closes/export.csv`;

export const listStaff = async () => (await client.get("/staff")).data.names || [];
export const addStaff = async (name) => (await client.post("/staff", { name })).data.names || [];
export const setStaff = async (names) => (await client.put("/staff", { names })).data.names || [];
export const getStaffMembers = async () => (await client.get("/staff/members")).data;
export const setStaffMembers = async (members) => (await client.put("/staff/members", { members })).data;

export const getSheetWebhook = async () => (await client.get("/settings/sheet-webhook")).data;
export const setSheetWebhook = async (url) => (await client.put("/settings/sheet-webhook", { url })).data;
export const testSheetWebhook = async () => (await client.post("/settings/sheet-webhook/test")).data;
